import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { PolService, CtbPolDto, CtbPolDet, CtbCtaDto, GralMonDto, CtbTpolDto } from './../ctb-pol.service';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
import { AddDocService } from './../../add-doc/add-doc.service';
import { ListaNegraService } from './../../add-doc/lista-negra.service';
import { CtbCcService } from '../../ctb-cc/ctb-cc.service';
import * as XLSX from 'xlsx';
import { jsPDF } from "jspdf";
import { PaginadorService, PageBusquedaObject } from '../../../paginador/paginador.service';

import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';
import { PeriodoEjercicioService } from '../../../control/periodo.service';
declare const $: any;
@Component({
  templateUrl: './formulario-ctb-pol.component.html',
  styleUrls: ['./formulario-ctb-pol.component.css'],
  providers: [PolService, LoginService, AddDocService, ListaNegraService],
  preserveWhitespaces: true
})

export class FormularioCtbPolComponent implements OnInit {

  public showList: boolean = false;
  public sinMenu: boolean = false;
  add_doc_indice_movimiento_ini_lista = 0;
  add_doc_indice_movimiento_fin_lista = 10;
  sucursales: any[] = [];
  empresa: String = '';
  maneja_cierre_anual: boolean = false;
  ejercicio_seleccionado: number;
  id_param: number;
  periodo_vigente: number;
  tipo_cierre: number = 2;
  movimiento_tmp = 0;
  indice_doc_mov = 0;
  cargado = true;
  lista_cc_autocompletado: any[] = [];
  indice_movimiento_ini_lista = 0;
  indice_movimiento_fin_lista = 10;
  indice_temp_cfdi = 0;
  indice_temp_cfdi_concepto = 0;
  pageNumberMov = 1;
  indice_temp_cfdi_impto = 0;
  consulta_lista_negra: any = { campos: [], lista: [] };
  rotate: any;
  detalle_cfdi: any = { conceptos: [] };
  doc_mov: any = { impuestos: [{}] };
  fecha_accesible = false;
  elemento: any = { nombre: '', contenido: '' };
  totalItems: number;
  busqueda: any = {};
  campos: any = [{ nombre: 'uuid', checked: true },
  { nombre: 'serie', checked: true },
  { nombre: 'folio', checked: true },
  { nombre: 'tipo', checked: true },
  { nombre: 'tipo_cfdi', checked: true },
  { nombre: 'fecha_emision', checked: true },
  { nombre: 'rfc_emisor', checked: true },
  { nombre: 'emisor', checked: false },
  { nombre: 'rfc_receptor', checked: true },
  { nombre: 'receptor', checked: false }];
  dto: CtbPolDto = new CtbPolDto();
  movimiento_poliza: CtbPolDet = new CtbPolDet();
  monedas: GralMonDto[] = [];
  indice: number;
  items: any[] = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
  documentos_asociados: any[] = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }
  ];
  errors: String[];
  cargos = 0;
  abonos = 0;
  todoSeleccionado = false;
  cargoTmp = 0;
  abonoTmp = 0;
  documentos_asociado = false;
  cuentas: CtbCtaDto[];
  tpolList: CtbTpolDto[] = [];
  arrayBuffer: any;
  opt = true;
  criteriaSearch: any | undefined = {};
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private location: Location, private paginadorService: PaginadorService,
    private router: Router,
    private polService: PolService,
    public loginService: LoginService,
    private activatedRoute: ActivatedRoute,
    private addDocService: AddDocService,
    private listaNegraService: ListaNegraService,
    private ctbCcService: CtbCcService, private PeriodoEjercicioService: PeriodoEjercicioService
  ) { }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.periodo_vigente = periodo ? periodo : 0;

      });
    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ejercicio_seleccionado = ejercicio ? ejercicio : 0;

    });

    this.maneja_cierre_anual = localStorage.getItem('maneja_cierre_anual') === 'true';

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['sinMenu'] !== undefined) {
        this.sinMenu = params['sinMenu'] === 'true' || params['sinMenu'] === true;
      }
    });
    this.empresa = this.loginService.usuario.empresa_seleccionada.titulo;
    this.codigoJQuery();
    this.inicializarBusqueda();
    this.cargarFormulario();

  }
  cargarSucursales() {
    this.polService.getSucursalByIdEmp(this.loginService.usuario.empresa_seleccionada.id).subscribe(
      response => {
        this.sucursales = response.contenido;
      }
    );
  }

  redondearCargo(movimiento: any): void {
  movimiento.cargo = Number(Number(movimiento.cargo).toFixed(2));
}
redondearAbono(movimiento: any): void {
  movimiento.abono = Number(Number(movimiento.abono).toFixed(2));
}
  async downloadPDF() {
    this.mostrarMensajeCarga('Generando PDF...');
    const titulo_pdf = this.dto.fecha + '' + this.getTipoPoliza() + this.dto.folio;
    let pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: 'letter',
      compress: false,
    })
    var source = document.getElementById("polizaImprimir");
    await pdf.html(
      source, {
      // Adjust your margins here (left, top, right ,bottom)
      margin: [30, 30, 30, 30]
    });
    pdf.save(titulo_pdf + '.pdf');
    this.cerrarMensajeCarga();
  }
  noValidadoCc(): boolean {
    if (this.movimiento_poliza) {
      if (this.movimiento_poliza.ctbCta.req_cc == true
        && (!this.movimiento_poliza.ctbPolDetCc
          || this.movimiento_poliza.ctbPolDetCc.length == 0)) {
        return true;
      }
      if (this.movimiento_poliza.ctbPolDetCc) {
        let sum_cargo = 0, sum_abono = 0;
        for (let item of this.movimiento_poliza.ctbPolDetCc) {
          if ((item.cargo == 0 && item.abono == 0) || item.ctb_cc.id == 0) {
            return true;
          }
          sum_cargo += item.cargo;
          sum_abono += item.abono;
        }
        if (this.movimiento_poliza.cargo < sum_cargo || this.movimiento_poliza.abono < sum_abono) {
          return true;
        }
      }
    }

    return false;

  }
  agregarCc() {
    this.movimiento_poliza.ctbPolDetCc?.push({ ctb_cc: { id: 0, titulo: '', codigo: '' }, cargo: 0, abono: 0, comentario: '' });
  }
  buscarCc(campo: string, valor: string, index: number) {
    if (valor !== '') {
      this.ctbCcService.getAutocompletado(valor, valor, this.loginService.empresa).subscribe(
        response => {
          this.lista_cc_autocompletado = response.contenido;
          if (this.movimiento_poliza.ctbPolDetCc) {
            for (let movimiento_poliza_cc of this.movimiento_poliza.ctbPolDetCc) {
              let indice_autocompletado = 0;
              for (let autocompletado_cc of this.lista_cc_autocompletado) {
                if (this.lista_cc_autocompletado[indice_autocompletado].visible == undefined) {
                  this.lista_cc_autocompletado[indice_autocompletado].visible = true;
                }
                if (movimiento_poliza_cc.ctb_cc.id == autocompletado_cc.id) {
                  this.lista_cc_autocompletado[indice_autocompletado].visible = false;
                }
                indice_autocompletado++;
              }
            }
            this.lista_cc_autocompletado = this.lista_cc_autocompletado.filter(item => !(item.visible == false));




            if (this.lista_cc_autocompletado && campo === 'titulo' && this.lista_cc_autocompletado.length == 1 &&
              this.lista_cc_autocompletado[0].titulo.toLowerCase() === valor.toLowerCase()) {
              this.movimiento_poliza.ctbPolDetCc[index].ctb_cc.id = this.lista_cc_autocompletado[0].id;
              this.movimiento_poliza.ctbPolDetCc[index].ctb_cc.codigo = this.lista_cc_autocompletado[0].codigo;
            }
            if (this.lista_cc_autocompletado && campo === 'codigo' && this.lista_cc_autocompletado.length == 1 &&
              this.lista_cc_autocompletado[0].codigo.toLowerCase() === valor.toLowerCase()) {
              this.movimiento_poliza.ctbPolDetCc[index].ctb_cc.id = this.lista_cc_autocompletado[0].id;
              this.movimiento_poliza.ctbPolDetCc[index].ctb_cc.titulo = this.lista_cc_autocompletado[0].titulo;
            }
          }
        });
    }
  }
  getTipoPoliza(): String {
    for (let item of this.tpolList) {
      if (this.dto.tpolId == item.id) {
        return item.titulo;
      }
    }
    return '';
  }
  getMoneda(): String {
    for (let item of this.monedas) {
      if (this.dto.monId == item.id) {
        return item.claveS;
      }
    }
    return '';
  }
  polizaInconclusa() {
    const poliza_tmp = localStorage.getItem('poliza_tmp');
    if (poliza_tmp != null && poliza_tmp.length > 10) {
      const audio = new Audio('assets/bambu_1.mp3');
      audio.play();
      Swal.fire({
        title: '¡Atención!',
        text: 'Existe una póliza inconclusa en el sistema ¿Desea retomarla?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.dto = JSON.parse(poliza_tmp) as CtbPolDto;
          this.validarInputPeriodoCerrado();
        } else {
          Swal.fire({
            title: '¿Está seguro?',
            text: 'Se borrará la copia de seguridad de la anterior póliza y sé creará una nueva, esta acción no sé puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
          }).then((result2) => {
            if (result2.value) {
              localStorage.setItem('poliza_tmp', null);
            } else {
              this.polizaInconclusa();
            }
          })
        }
      })
    }
  }
  distribuirMontosCc() {
    if (this.movimiento_poliza.ctbPolDetCc.length > 0 && this.movimiento_poliza.ctbPolDetCc.length != undefined) {
      const cargo = (this.movimiento_poliza.cargo / this.movimiento_poliza.ctbPolDetCc.length);
      const abono = (this.movimiento_poliza.abono / this.movimiento_poliza.ctbPolDetCc.length);
      for (let x = 0; x < this.movimiento_poliza.ctbPolDetCc.length; x++) {
        this.movimiento_poliza.ctbPolDetCc[x].cargo = cargo;
        this.movimiento_poliza.ctbPolDetCc[x].abono = abono;
      }
    }
  }
  uploadDataXls(event: any): void {
    this.mostrarMensajeCarga('Cargando datos del excel');
    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      const bstr = arr.join("");
      const workbook = XLSX.read(bstr, { type: "binary" });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];
      const array = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.llenarPolizaConArrayExcel(array);
    }
    fileReader.readAsArrayBuffer(file);
    this.cerrarMensajeCarga();
  }
  llenarPolizaConArrayExcel(array: any[]) {
    let valido = true;
    let moneda_presente = false;

    if (array[0].MONEDA == undefined || array[0].TIPO == undefined || array[1].__EMPTY == undefined
      || array[1].__EMPTY_1 == undefined
      || array[1].__EMPTY.toUpperCase() != 'REFERENCIA'
      || array[1].__EMPTY_1.toUpperCase() != 'CONCEPTO') {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'El formato es invalido'
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      });
    }
    for (let x = 0; x < this.monedas.length; x++) {
      if (array[0].MONEDA.toUpperCase() == this.monedas[x].claveS.toUpperCase()) {
        moneda_presente = true;
        break;
      }
    }
    if (moneda_presente === false) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'La moneda "' + array[0].MONEDA + '" no está presente en el sistema.'
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      });
    }
    let tpol_presente = false;
    for (let x = 0; x < this.tpolList.length; x++) {
      if (array[0].TIPO.toUpperCase() == this.tpolList[x].titulo.toUpperCase()) {
        tpol_presente = true;
        break;
      }
    }
    if (tpol_presente === false) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'El tipo de póliza "' + array[0].TIPO + '" no está presente en el sistema.'
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      });
    }
    if (array.length <= 3) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'El documento no tiene movimientos.'
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      });
    }

    const estructura_empresa = this.loginService.usuario.empresa_seleccionada.estructura1;
    for (let x = 2; x < array.length; x++) {

      if (!array[x].TIPO == undefined) {
        if ((array[x].TIPO as string).includes('-')) {
          const estructura_excel = 'X'.repeat(array[x].TIPO.split('-')[0].length) + '-'
            + 'X'.repeat(array[x].TIPO.split('-')[1].length) + '-' + 'X'.repeat(array[x].TIPO.split('-')[2].length);
          if (estructura_excel != estructura_empresa) {
            Swal.fire({
              icon: 'error',
              title: 'Mensaje',
              text: 'La estructura de las cuentas debe ser ' + estructura_empresa + '.'
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            });
            valido = false;
            break;
          }
          if (isNaN(array[x].MONEDA) && array[x].MONEDA !== undefined) {
            Swal.fire({
              icon: 'error',
              title: 'Mensaje',
              text: 'El cargo "' + array[x].MONEDA + '" de la fila ' + (x + 3) + ' no es valido.'
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            });
            valido = false;
            break;
          }
          if (isNaN(array[x].CONCEPTO) && array[x].CONCEPTO !== undefined) {
            Swal.fire({
              icon: 'error',
              title: 'Mensaje',
              text: 'El abono "' + array[x].CONCEPTO + '" de la fila ' + (x + 3) + ' no es valido.'
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            });
            valido = false;
            break;
          }
        }
      }

    } if (valido === true && moneda_presente === true && tpol_presente === true) {
      this.dto.concepto = array[0].CONCEPTO != null ? array[0].CONCEPTO : '';
      for (let x = 0; x < this.monedas.length; x++) {
        if (array[0].MONEDA.toUpperCase() == this.monedas[x].claveS.toUpperCase()) {
          this.dto.monId = this.monedas[x].id;
          break;
        }
      }
      for (let x = 0; x < this.tpolList.length; x++) {
        if (array[0].TIPO.toUpperCase() == this.tpolList[x].titulo.toUpperCase()) {
          this.dto.tpolId = this.tpolList[x].id;
          break;
        }
      }
      let i = 2;
      while ((array[i].TIPO as string).includes('-')) {

        this.movimiento_poliza.ctbCta.cuenta = array[i].TIPO;
        this.movimiento_poliza.ctbCta.nombre = '(Autollenado)';
        this.movimiento_poliza.concepto = array[i].__EMPTY_1 != null ? array[i].__EMPTY_1 : '';
        this.movimiento_poliza.cargo = Number(array[i].MONEDA != null && array[i].MONEDA != '' ? array[i].MONEDA : 0);
        this.movimiento_poliza.abono = Number(array[i].CONCEPTO != null && array[i].CONCEPTO != '' ? array[i].CONCEPTO : 0);
        this.movimiento_poliza.referencia = array[i].__EMPTY != null ? array[i].__EMPTY : '';
        this.asignarctbPolDet();
        i++;
      }
    }
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  cerrarPoliza() {
    if (!this.id_param && (this.dto.add_doc_id.length > 0 || this.dto.ctbPolDet.length > 0)) {
      localStorage.setItem('poliza_tmp', JSON.stringify(this.dto));
    }
    if (this.sinMenu) {
      this.cerrarVentana();
    } else {
      this.location.back();
    }
  }

  removerCtbPolDetCc(index: number) {
    this.movimiento_poliza.ctbPolDetCc?.splice(index, 1);
  }
  async cargarFormulario() {
     Swal.fire({
      title: 'TNK Ledger',
      html: 'Consultando información...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.cargarSucursales();
    await this.polService.tpolGrupoGet(this.loginService.usuario.empresa_seleccionada.id).toPromise().then(response => {
      this.tpolList = response;
      if (!this.tpolList || this.tpolList.length === 0) {
        Swal.fire({
          title: 'Error',
          text: `No existen tipos de poliza registrados`,
          allowOutsideClick: false,
          confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/contabilidad/proceso/ctb-pol']);
          }
        });
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: err.error.mensaje
      })
    });
    await this.polService.getMonByEmpId(this.loginService.empresa).toPromise().then(response => {
      this.monedas = response.contenido as GralMonDto[];
      if (!this.monedas || this.monedas.length === 0) {
        Swal.fire({
          title: 'Error',
          text: `No existen monedas registradas`,
          allowOutsideClick: false,
          confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/contabilidad/proceso/ctb-pol']);
          }
        });
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: err.error.mensaje
      })
      console.log(err);
    });
    this.delay(150).then(any => {
      this.activatedRoute.params.subscribe(params => {
        this.id_param = params['id'];
        if (this.id_param) {
          this.cargarPoliza();
        } else {
          this.dto = new CtbPolDto();
          this.dto.estatus = 2;
          this.dto.tpolId = this.tpolList[0].id;
          this.dto.monId = this.monedas[0].id;
          this.dto.sucId = this.loginService.sucursal as number;
          this.cargarDatosPeriodoActual();
          this.cargado = true;
          this.cerrarMensajeCarga();
          this.polizaInconclusa();
        }
      });
    });
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log());
  }
  inicializarBusqueda() {
    this.busqueda.criteriaSearch = {};
    this.busqueda.criteriaSearch['tipoCfdi'] = 0;
    this.busqueda.criteriaSearch['asociado'] = 0;
    this.busqueda.itemsPerPage = 15;
    this.busqueda.pageNumber = 0;
  }
  codigoJQuery() {
    $(document).keypress(function (e) {
      if (e.which === 13) {
        e.preventDefault();
        return false;
      }
    });
  }

  calcularFechaVencimiento() {
    const date = new Date(this.dto.fecha + 'T00:00:00');
    date.setDate(date.getDate() + (this.dto.dias_credito));
    this.dto.fecha_ven_cre = this.convertDate(date);
  }
  descargarPdf(id: number) {
    Swal.fire({
      title: 'Mensaje',
      html: 'Descargando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.addDocService.getNombreContenidoById(id).subscribe(response => {
          this.elemento.nombre = response.nombre.replace('.xml', '');
          this.elemento.contenido = response.contenido;
          this.addDocService.descargaCfdiPdf(this.elemento).subscribe(response2 => {
            this.cerrarMensajeCarga();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(response2);
            //a.download = response.nombre.replace('.xml', '');
            //document.body.appendChild(a);
            window.open(a.href, 'download_window', 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
            window.focus();
          }, err2 => {
            this.cerrarMensajeCarga();
            if (err2.error.mensaje == null || '' || undefined) {
              err2.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'Mensaje',
              text: err2.error.mensaje
            });
            console.log(err2);
          });
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'Mensaje',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });
  }
  descargarXml(id: number): void {
    this.addDocService.descargaXml(id).subscribe((response: any) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = 'Documentos  ' + fechaActual.getFullYear() + '-' +
        ((fechaActual.getMonth() + 1) < 10 ? '0' + (fechaActual.getMonth() + 1) :
          (fechaActual.getMonth() + 1)) + '-' +
        (fechaActual.getDay() < 10 ? '0' + fechaActual.getDay() : fechaActual.getDay()) + '.zip';
      document.body.appendChild(a);
      a.click();
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'No documentos para exportar al xml';
      }
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  convertDate(date: Date) {
    const yyyy = date.getFullYear().toString();
    const mm = (date.getMonth() + 1).toString();
    const dd = date.getDate().toString();

    const mmChars = mm.split('');
    const ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : '0' + mmChars[0]) + '-' + (ddChars[1] ? dd : '0' + ddChars[0]);
  }

  eliminarAsociacion(id: number, index: number) {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de eliminar la asociación de este CFDI a la póliza?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        for (let x = 0; x < this.dto.add_doc_id.length; x++) {
          if (this.dto.add_doc_id[x] === id) {
            this.dto.add_doc_id.splice(x, 1);
            this.documentos_asociados.splice(index, 1);
            if (this.documentos_asociados.length === 0) {
              this.documentos_asociados = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
            }
            Swal.fire('Mensaje', 'Operación realizada con éxito', 'success');
            break;
          }
        }
      }
    });
  }
  obtenerDocumentoPorIdRelacionado(id: number) {
    this.documentos_asociado = true;
    //this.obtenerDocumentoPorId(id);
  }
  aumentarIndiceDoc() {
    this.indice_doc_mov = this.indice_doc_mov + 1;
  }
  disminuirIndiceDoc() {
    this.indice_doc_mov = this.indice_doc_mov - 1;
  }
  actualizarImpuesto(entity: any) {
    this.addDocService.putImpto(entity).subscribe(
      response => {
        Swal.fire('Mensaje', response.mensaje, 'success');
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  cargarCfdisAsociados(forzar: boolean) {
    if ((this.documentos_asociados.length === 1 && forzar == false) || forzar === true) {
      this.addDocService.cargarCfdisAsociados(this.dto.add_doc_id).subscribe(
        response => {
          this.documentos_asociados = response.contenido;
          if (this.documentos_asociados.length === 0) {
            // this.documentos_asociados = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
          }
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'Mensaje',
            text: err.error.mensaje
          });
          console.log(err);
        });
    }
  }
  catalogo() {
    this.documentos_asociado = false;
    this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.addDocService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        for (let x = 0; x < this.items.length; x++) {
          this.items[x].estatus_verificado = 1;
        }
        this.totalItems = response.contenido.totalElements;
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  asignarMovimientoCfdi(tipo: number, cantidad: number, concepto: string) {
    this.movimiento_poliza.concepto = concepto;
    if (tipo === 1) {
      this.movimiento_poliza.cargo = cantidad;
      this.movimiento_poliza.abono = 0;
    } else {
      this.movimiento_poliza.cargo = 0;
      this.movimiento_poliza.abono = cantidad;
    }
  }
  /**  obtenerDocumentoPorId(id: number) {
     this.addDocService.getById(id).subscribe(
       response => {
         this.doc_mov = response.contenido.general_cfdi;
         this.detalle_cfdi = response.contenido.detalle_cfdi;
       }, err => {
         this.items[this.indice_temp_cfdi].seleccionado = ((!this.items[this.indice_temp_cfdi].seleccionado) ? true : false);
         if (err.error.mensaje == null || '' || undefined) {
           err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
         }
         Swal.fire({
           icon: 'error',
           title: 'Mensaje',
           text: err.error.mensaje
         });
         console.log(err);
       });
   }*/
  seleccionarTodo() {
    for (let x = 0; x < this.items.length; x++) {
      this.seleccionar(x);
    }
    this.todoSeleccionado = this.todoSeleccionado === false ? true : false;
  }
  cfdiDePoliza(add_doc_id: number): boolean {
    for (let x = 0; x < this.dto.add_doc_id.length; x++) {
      if (this.dto.add_doc_id[x] as number === add_doc_id) {
        return true;
      }
    }
    return false;
  }
  seleccionar(index: number) {
    this.movimiento_tmp = this.dto.ctbPolDet.length + 1;
    this.indice_temp_cfdi = index;
    if (this.doc_mov.id as number !== this.items[index].id as number) {
      //this.obtenerDocumentoPorId(this.items[index].id);
    }
    if (this.cfdiDePoliza(this.items[index].id as number)) {
      for (let x = 0; x < this.dto.add_doc_id.length; x++) {
        if (this.dto.add_doc_id[x] as number === this.items[index].id as number) {
          this.dto.add_doc_id.splice(x, 1);
          break;
        }
      }
    } else {
      this.dto.add_doc_id.push(this.items[index].id);
    }
    this.items[index].seleccionado = ((!this.items[index].seleccionado) ? true : false);
    if (!this.id_param) {
      localStorage.setItem('poliza_tmp', JSON.stringify(this.dto));
    }
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.catalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.catalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.itemsPerPage = 5;
    this.busqueda.pageNumber = 0;
    if (this.busqueda.criteriaSearch['fecha'] != null) {
      this.busqueda.column = 'fecha';
      this.busqueda.sort = true;
      this.busqueda.pageNumber = 0;
      this.busqueda.order = 'asc';
    }
    this.catalogo();
  }
  limpiarBusqueda(): void {
    setTimeout(() => {
      this.busqueda.criteriaSearch = {};
      this.busqueda.criteriaSearch['tipoCfdi'] = 0;
      this.busqueda.criteriaSearch['asociado'] = 0;
      this.buscarEnCatalogo();
    },
      50);
  }
  getMonedas(): Promise<any> {
    return;
  }
  estatusToogle(estatus: number) {
    this.dto.estatus = estatus;
  }
  creditoToogle(estatus: boolean) {
    this.dto.credito = estatus;
  }

  polizaAjusteToogle(estatus: boolean) {
    this.dto.poliza_ajuste = estatus;
  }
  cargarDatosPeriodoActual() {
    this.polService.getDatosCierre(this.loginService.empresa).subscribe(
      response => {

        if (!this.id_param) {
          this.fecha();
        }
        this.validarInputPeriodoCerrado();
      }
    );
  }
  esDiciembre(fecha: string): boolean {
    let [y, m, d] = fecha.split('-');
    const date = new Date(y as any, m as any - 1, d as any);
    return date.getMonth() === 11; // 11 representa diciembre en JavaScript
  }

  validarPeriodoCerrado() {
    const fecha = this.dto.fecha;
    this.cargarDatosPeriodoActual();
    if (this.periodo_vigente === 13
      && this.ejercicio_seleccionado === parseInt(fecha.split('-')[0], 10)
      && 12 === parseInt(this.dto.fecha.split('-')[1], 10)
      && 31 === parseInt(this.dto.fecha.split('-')[2], 10)) {
      return true;
    } else {
      if (this.periodo_vigente !== parseInt(fecha.split('-')[1], 10)
        || this.ejercicio_seleccionado !== parseInt(fecha.split('-')[0], 10)) {
        return false;
      } else {
        return true;
      }
    }
  }
  validarInputPeriodoCerrado() {

    const fecha = this.dto.fecha.split('-');

    const anio = parseInt(fecha[0], 10);
    const mes = parseInt(fecha[1], 10);
    const dia = parseInt(fecha[2], 10);

    // Cierre ejercicio (periodo 13)
    if (
      this.periodo_vigente === 13 &&
      this.ejercicio_seleccionado === anio &&
      mes === 12 &&
      dia === 31
    ) {

      this.fecha_accesible = false;

      return;

    }

    // Cierre por periodo
    if (this.tipo_cierre === 2) {

      this.fecha_accesible =
        this.periodo_vigente !== mes ||
        this.ejercicio_seleccionado !== anio;

      return;

    }

    // Cierre ejercicio
    if (this.tipo_cierre === 1) {

      this.fecha_accesible =
        this.ejercicio_seleccionado !== anio;

      return;

    }

    this.fecha_accesible = false;

  }
  cargoOut() {
    if (this.movimiento_poliza.cargo == null) {
      this.movimiento_poliza.cargo = this.cargoTmp;
    }
    this.cargoTmp = 0;
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  abonoOut() {
    if (this.movimiento_poliza.abono == null) {
      this.movimiento_poliza.abono = this.abonoTmp;
    }
    this.abonoTmp = 0;
  }
  cargoIn() {
    this.cargoTmp = this.movimiento_poliza.cargo;
    //this.movimiento_poliza.cargo = null;
  }
  abonoIn() {
    this.abonoTmp = this.movimiento_poliza.abono;
    //this.movimiento_poliza.abono = null;
  }
  fecha() {

    let dd;
    let mm;
    if (this.periodo_vigente < 13) {
      dd = 1;
      mm = this.periodo_vigente;
    } else {
      dd = 31;
      mm = 12;
    }
    const yyyy = this.ejercicio_seleccionado;
    let ddStr = '';
    let mmStr = '';
    if (dd < 10) {
      ddStr = '0' + dd
    } else {
      ddStr = dd + '';
    }

    if (mm < 10) {
      mmStr = '0' + mm
    } else {
      mmStr = mm + '';
    }
    if(mmStr == '00'){
      mmStr = '01';
    }
    console.log('fecha: ' + yyyy + '-' + mmStr + '-' + ddStr);
    this.dto.fecha = yyyy + '-' + mmStr + '-' + ddStr;
    this.dto.fecha_ajuste = this.dto.fecha;
  }
  navegador(): String {
    if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf('Safari') !== -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
      return 'Firefox';
    } else {
      return 'unknown';
    }
  }
  nuevoPolDet() {
    this.movimiento_poliza = new CtbPolDet();
    this.indice = null;
  }
  actualizarMovimiento(ctbPolDet: CtbPolDet, indice: number) {
    this.movimiento_poliza = new CtbPolDet();
    this.movimiento_poliza.id = ctbPolDet.id;
    this.movimiento_poliza.ctbPolId = ctbPolDet.ctbPolId;
    this.movimiento_poliza.cargo = ctbPolDet.cargo;
    this.movimiento_poliza.abono = ctbPolDet.abono;
    this.movimiento_poliza.concepto = ctbPolDet.concepto;
    this.movimiento_poliza.ctbCta.id = ctbPolDet.ctbCta.id;
    this.movimiento_poliza.ctbCta.cuenta = ctbPolDet.ctbCta.cuenta;
    this.movimiento_poliza.ctbCta.nombre = ctbPolDet.ctbCta.nombre;
    this.movimiento_poliza.ctbCta.naturaleza = ctbPolDet.ctbCta.naturaleza;
    this.movimiento_poliza.ctbCta.req_cc = ctbPolDet.ctbCta.req_cc;
    this.movimiento_poliza.num_mov = ctbPolDet.num_mov;
    if (ctbPolDet.ctbPolDetCc) {
      for (let item of ctbPolDet.ctbPolDetCc) {
        this.movimiento_poliza.ctbPolDetCc?.push({
          ctb_cc: {
            id: item.ctb_cc.id,
            codigo: item.ctb_cc.codigo,
            titulo: item.ctb_cc.titulo
          }, cargo: item.cargo, abono: item.abono, comentario: item.comentario
        });
      }
    }
    this.movimiento_poliza.referencia = ctbPolDet.referencia;

    this.indice = indice;
  }
  calcularSumasIguales() {
    this.cargos = 0;
    this.abonos = 0;
    if (this.dto.ctbPolDet) {
      for (let x = 0; x < this.dto.ctbPolDet.length; x++) {
        this.cargos += this.dto.ctbPolDet[x].cargo;
        this.abonos += this.dto.ctbPolDet[x].abono;
      }
    }
  }
eliminarctbPolDet(indice: number) {
  Swal.fire({
    title: '¿Eliminar movimiento?',
    text: 'Esta acción eliminará el movimiento de la póliza. ¿Deseas continuar?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.value) {
      this.dto.ctbPolDet.splice(indice, 1);
      this.calcularSumasIguales();

      this.showNotification('El movimiento se eliminó correctamente.');
    }
  });
}
  esEntero(numero) {
    if (numero % 1 == 0) {
      return true;
    } else {
      return false;
    }
  }
  showNotification(mensaje: any) {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: mensaje,
      showConfirmButton: false,
      timer: 1500
    })
  }
  asignarctbPolDet(): boolean {
    if (this.indice != null) {
      this.dto.ctbPolDet[this.indice] = this.movimiento_poliza;
      this.indice = null;
      this.movimiento_poliza = new CtbPolDet();
      this.calcularSumasIguales();this.showNotification('El movimiento se guardó correctamente.');
      return true;
    } else {
      this.indice = null;
      this.movimiento_poliza.num_mov = this.dto.ctbPolDet.length + 1;
      this.dto.ctbPolDet.push(this.movimiento_poliza);
      /**let paginas = this.dto.ctbPolDet.length / 10;
      paginas = this.esEntero(paginas) ? paginas : Math.ceil(paginas);
      for (let x = 1; x < paginas + 1; x ++) {
        if (this.dto.ctbPolDet[this.dto.ctbPolDet.length - 1].num_mov > ((x * 10) - 10)
        && (x * 10) > this.dto.ctbPolDet[this.dto.ctbPolDet.length - 1].num_mov) {
        this.cambiarPaginaMovimientos(x);
        this.pageNumberMov = x - 1;
        }
      }
      **/
      this.movimiento_poliza = new CtbPolDet();
      this.calcularSumasIguales();
      // this.showNotification('Movimiento guardado con éxito.');
      if (!this.id_param) {
        localStorage.setItem('poliza_tmp', JSON.stringify(this.dto));
      }
      return true;
    }
  }
  getTpolGrupo(): Promise<any> {
    return;
  }
  cargarPoliza() {
   
    this.polService.polGet(this.id_param).toPromise().then(
      response => {
        this.dto = response.contenido as CtbPolDto;




        this.calcularSumasIguales();
        this.cargarDatosPeriodoActual();
        this.cargado = true;
        this.cerrarMensajeCarga();
      }, err => {
        this.cargado = true;
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }

  buscadorMovimientoPoliza(campo: string, valor: string) {
    if (valor === '') {
      this.dto.ctbPolDet.sort(function (a, b) {
        if (a.num_mov > b.num_mov) {
          return 1;
        }
        if (a.num_mov < b.num_mov) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

    } else {
      for (let x = 0; x < this.dto.ctbPolDet.length; x++) {
        switch (campo) {
          case 'num_mov':
            if (valor === this.dto.ctbPolDet[x].num_mov.toString()) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'cuenta':
            if (this.comparar(valor, this.dto.ctbPolDet[x].ctbCta.cuenta as string)) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'nombre':
            if (this.comparar(valor, this.dto.ctbPolDet[x].ctbCta.nombre as string)) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'cargo':
            if (valor === this.dto.ctbPolDet[x].cargo.toString()) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'abono':
            if (valor === this.dto.ctbPolDet[x].abono.toString()) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'referencia':
            if (this.comparar(valor, this.dto.ctbPolDet[x].referencia)) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
          case 'concepto':
            if (this.comparar(valor, this.dto.ctbPolDet[x].concepto)) {
              this.dto.ctbPolDet.unshift(this.dto.ctbPolDet.splice(x, 1)[0]);
            }
            break;
        }
      }
    }
  }

  comparar(valor_busqueda: string, valor_fijo: string) {
    valor_busqueda = valor_busqueda.toLowerCase();
    valor_fijo = valor_fijo.toLowerCase();
    for (let i = 0; i < valor_busqueda.length; i++) {
      if (valor_busqueda.slice(0, i) !== valor_fijo.slice(0, i)) {
        return false;
      }
    }
    return true;
  }

  cambiarPaginaMovimientos(event: any): void {
    const pagina = event.page;
    this.indice_movimiento_ini_lista = (10 * pagina) - 10;
    this.indice_movimiento_fin_lista = (10 * pagina);

  }
  cambiarPaginaMovimientosAddDoc(event: any): void {
    const pagina = event;
    this.add_doc_indice_movimiento_ini_lista = (10 * pagina) - 10;
    this.add_doc_indice_movimiento_fin_lista = (10 * pagina);
  }
  crear() {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Guardando cambios...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.consulta_lista_negra = { campos: [], lista: [] };
    this.detalle_cfdi = { conceptos: [] };
    this.doc_mov = { impuestos: [{}] };
    this.elemento = { nombre: '', contenido: '' };
    this.items = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
    this.documentos_asociados = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
    if (this.dto.monId == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione una moneda valida'
      });
    } else if (this.dto.tpolId == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione un tipo de póliza valida'
      });
    } else if (this.dto.fecha == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione una fecha valida'
      });
    } else {
      localStorage.setItem('poliza_tmp', JSON.stringify(this.dto));
      this.dto.empId = this.loginService.empresa as number;
      if ((this.periodo_vigente == 13 && this.maneja_cierre_anual == false)) {
        this.dto.mes = 13;
      }
      this.mostrarMensajeCarga('Guardando cambios');
      this.polService.polPost(this.dto, this.loginService.usuario.id).subscribe(response => {
        this.cerrarMensajeCarga();
        localStorage.setItem('poliza_tmp', null);
        Swal.fire('Mensaje', response.mensaje, 'success');
        this.router.navigate(['/contabilidad/proceso/ctb-pol']);
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        });
      });
    }
    this.cargado = true;
  }

  buscarCuenta( busqueda: String) {
        this.criteriaSearch['cuenta_nombre'] = busqueda;
    this.criteriaSearch['clasificacion'] = 4;
    this.criteriaSearch['emp'] = this.loginService.empresa;
    this.polService.postBusqueda(this.criteriaSearch).subscribe(response => {
      
            this.cuentas = response.contenido.map((item: any) => ({
        ...item,
        cuenta_nombre: `${item.cuenta} - ${item.nombre}`
      }))//.filter((item: any) => item.id !== this.movimiento_poliza.ctbCta.id);
      if (this.cuentas != null && this.cuentas.length === 1) {
            if (this.criteriaSearch['cuenta_nombre'].toLowerCase().includes(this.cuentas[0].cuenta.toLowerCase())
              || this.criteriaSearch['cuenta_nombre'].toLowerCase().includes(this.cuentas[0].nombre.toLowerCase())) {
              this.movimiento_poliza.ctbCta = this.cuentas[0];
              //this.cuentas = [];
              this.polService.validarCuentaSeleccionada(this.movimiento_poliza.ctbCta.id, this.loginService.empresa).subscribe(
                response_val => {

                }, err_val => {
                  this.movimiento_poliza.ctbCta = new CtbCtaDto();


                  Swal.fire({
                    title: 'Atención',
                    text: err_val.error.mensaje,
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    confirmButtonText: 'Si'
                  }).then((result) => {
                    if (result.value) {
                      this.router.navigate(['/contabilidad/catalogo/act-fijo']);
                    }
                  });
                }
              );
            }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('Mensaje', err.error.mensaje, 'error');
    });
  }

  actualizar() {
    if (this.dto.estatus == 3) {
      Swal.fire({
        title: '¿Está seguro de cancelar esta póliza?',
        text: `Las relaciones con CFDIS y la DIOT serán afectadas durante esta operación`,
        showCancelButton: true,
        cancelButtonText: 'Atrás',
        confirmButtonText: 'Continuar'
      }).then((result) => {
        if (result.value) {
          this.ejecutarActualizacion();
        }
      });
    } else {
      this.ejecutarActualizacion();
    }
  }
  ejecutarActualizacion() {
    
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Guardando cambios...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.consulta_lista_negra = { campos: [], lista: [] };
    this.detalle_cfdi = { conceptos: [] };
    this.doc_mov = { impuestos: [{}] };
    this.elemento = { nombre: '', contenido: '' };
    this.items = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
    this.documentos_asociados = [{ addDocConcepto: [{ add_doc_concepto_impto: [{}] }] }];
    if (this.dto.monId == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione una moneda valida'
      });
    } else if (this.dto.tpolId == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione un tipo de póliza valida'
      });
    } else if (this.dto.fecha == null) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: 'Seleccione una fecha valida'
      });
    } else {
      this.dto.empId = this.loginService.empresa as number;

      if (this.dto.poliza_ajuste === true) {
        this.dto.mes = 13;
      } else {
        this.dto.mes = new Date(this.dto.fecha + 'T00:00:00').getMonth() + 1;
      }

      this.mostrarMensajeCarga('Guardando cambios');
      this.polService.polPut(this.dto, this.loginService.usuario.id).subscribe(response => {
        this.cerrarMensajeCarga();
        Swal.fire('Mensaje', response.mensaje, 'success');
        if (this.sinMenu) {
          this.cerrarVentana();
        } else {
          this.router.navigate(['/contabilidad/proceso/ctb-pol']);
        }
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        })
      });
    }
    this.cargado = true;

  }


  seleccionarPeriodo13(event: Event): void {
    const valorSeleccionado = (event.target as HTMLSelectElement).value === 'true';
    this.dto.poliza_ajuste = valorSeleccionado;
  }
  mostrarMensajeCarga(mensaje: string) {
    //this.cargado = false;

  }
  cerrarMensajeCarga() {
    Swal.close();
  }
  consultarListaNegra(rfc: string, indice: number) {
    if (this.consulta_lista_negra.lista.length === 0 ||
      (this.consulta_lista_negra.lista.length > 0
        && this.consulta_lista_negra.lista[0].rfc !== rfc)
    ) {
      Swal.fire({
        title: 'Mensaje',
        html: 'Verificando...',
        timerProgressBar: true,
        showConfirmButton: false,
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
          this.listaNegraService.consultarEstatusRfc(rfc).subscribe(
            response => {
              Swal.close();
              this.consulta_lista_negra = response.contenido;
              if (this.consulta_lista_negra.lista.length === 0) {
                this.items[indice].estatus_verificado = 2;
                this.consulta_lista_negra = { campos: [], lista: [] };
              }
              if (this.consulta_lista_negra.lista.length > 0) {
                if (this.verificarSentenciaFavorable(this.consulta_lista_negra.lista) === false) {
                  this.items[indice].estatus_verificado = 3;
                } else {
                  this.items[indice].estatus_verificado = 2;
                  this.consulta_lista_negra = { campos: [], lista: [] };
                }
              }
            }, err => {
              if (err.error.mensaje == null || '' || undefined) {
                err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
              }
              Swal.close();
              Swal.fire({
                icon: 'error',
                title: 'Mensaje',
                text: err.error.mensaje
              });
            });
        }
      });

    }
  }
  verificarSentenciaFavorable(lista: any[]): boolean {
    for (let x = 0; x < lista.length; x++) {
      if (lista[x].situacion_del_contribuyente !== 'Sentencia Favorable') {
        return false;
      }
    }
    return true;
  }

  cerrarVentana() {
    window.close();
  }
}
